// extracted by mini-css-extract-plugin
module.exports = {"text__button":"styles-module--text__button--7jMqn","text__image":"styles-module--text__image--2-mZ2","text__image-caption":"styles-module--text__image-caption--3APi5"};